module.exports = __webpack_public_path__ + "static/army-of-none-9cb21050f3379ea20a24a60f6f72cd52.jpg";